import Drupal from '../modules/Drupal'

export default class PathUtil {
  static makePath(alias: string): string {
    let result = alias
    if (Drupal.common.basePath !== '/') {
      result = Drupal.common.basePath + alias.replace(/^\//, '')
    }
    return result
  }
}
